import { render, staticRenderFns } from "./logo-list.vue?vue&type=template&id=bbf27e2c&scoped=true&"
import script from "./logo-list.vue?vue&type=script&lang=js&"
export * from "./logo-list.vue?vue&type=script&lang=js&"
import style0 from "./logo-list.vue?vue&type=style&index=0&id=bbf27e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf27e2c",
  null
  
)

export default component.exports